import { render, staticRenderFns } from "./DeveloperAgreement.vue?vue&type=template&id=2e69a93b&scoped=true"
import script from "./DeveloperAgreement.vue?vue&type=script&lang=js"
export * from "./DeveloperAgreement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e69a93b",
  null
  
)

export default component.exports